import type { MaintenanceStatusResponse } from "./types";

const STATUS_URL = "/api/status/";

/**
 * Fetches current maintenance status (no auth).
 * Uses fetch so the request is not sent through the axios client (avoids 503 redirect loop).
 */
export async function getMaintenanceStatus(): Promise<MaintenanceStatusResponse> {
  const url = `${window.location.origin}${STATUS_URL}`;
  const response = await fetch(url, {
    method: "GET",
    headers: { Accept: "application/json" },
    credentials: "same-origin",
  });
  if (!response.ok) {
    throw new Error(`Maintenance status failed: ${response.status}`);
  }
  return response.json() as Promise<MaintenanceStatusResponse>;
}
